import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Card, Button, Divider, message, Space, Typography, Form, Checkbox, Empty, Modal } from "antd";
import { FileDoneOutlined } from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { AuthContext } from "../../../contexts/AuthContext";
import http from "../../../services/http";
const { Text } = Typography;

export const TermosConfirmacaoLogin = () => {
  const [loading, setLoading] = useState();
  const { session, atualizarTermos, encerrarSessao } = useContext(AuthContext);
  const [modal, contextHolder] = Modal.useModal();
  const [form] = Form.useForm();

  // DADOS
  const [dados, setDados] = useState([]);

  useEffect(() => {
    if (session.termos_pendentes.length > 0) {
      carregarTermo(session.termos_pendentes[0]);
    }
  }, [session.termos_pendentes]);

  const realizarLogout = async () => {
    await http("get", "v1/autenticacao/logout", []);
    message.success("Logout realizado com sucesso!");
    await encerrarSessao();
  };

  // CARREGAR TERMO
  const carregarTermo = async (id_termo) => {
    setLoading(true);
    const api = await http("get", `v1/termos/carregar_confirmacao/${id_termo}`, []);
    if (api.statusCode === 200) {
      if (!api.response.data) {
        atualizarTermos(session.termos_pendentes.filter((e) => e !== id_termo));
      }
      setDados(api.response.data);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // SALVAR TERMO
  const salvarTermo = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/termos_confirmacao/salvar`, formulario);
    if (api.statusCode === 200) {
      message.success("Termo confirmado com sucesso!");
      if (session.termos_pendentes.length > 0) {
        atualizarTermos(session.termos_pendentes.filter((e) => e !== formulario.id_cad_termos_ciencia));
      }
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // PRORROGAR TERMO
  const prorrogarTermo = async (id_termo) => {
    if (!id_termo) return;
    setLoading(true);
    const api = await http("post", `v1/termos_confirmacao/prorrogar`, { id_cad_termos_ciencia: id_termo });
    if (api.statusCode === 200) {
      if (session.termos_pendentes.length > 0) {
        atualizarTermos(session.termos_pendentes.filter((e) => e !== id_termo));
      }
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  const onSubmit = (values) => {
    if (!dados.id) return;
    let erros = 0;
    dados.itens &&
      dados.itens.map((e) => {
        let val = values.itens && values.itens.find((val) => val === e.id);
        if (!val) erros++;
      });
    if (erros > 0) {
      message.error("Aceite os termos para prosseguir!");
      return;
    }
    values.id_cad_termos_ciencia = dados.id;

    // ENVIAR CONFIRMAÇÃO
    salvarTermo(values);
  };

  const renderTermo = () => {
    return (
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col className="gutter-row" span={24}>
          <Space className="content-header-profile" wrap>
            <Text strong>{dados.descricao}</Text>
          </Space>
        </Col>

        <Divider />
        <Form name="login" onFinish={onSubmit} layout="vertical" form={form}>
          <Space direction="vertical" style={{ width: "100%", padding: 10 }} size={10}>
            <Text className="line-break">{dados.texto}</Text>
            {dados.itens && dados.itens.length > 0 && (
              <Form.Item name="itens">
                <Checkbox.Group>
                  <Space direction="vertical" style={{ width: "100%", padding: 10 }} size={10}>
                    {dados.itens &&
                      dados.itens.map((i) => {
                        return (
                          <Checkbox disabled={loading} value={i.id} key={i.id}>
                            <Text className="line-break">{i.descricao}</Text>
                          </Checkbox>
                        );
                      })}
                  </Space>
                </Checkbox.Group>
              </Form.Item>
            )}
            <Space wrap>
              <Button
                onClick={() =>
                  modal.confirm({
                    title: "Deseja confirmar este termo?",
                    okText: "Sim",
                    cancelText: "Cancelar",
                    onOk() {
                      form.submit();
                    },
                  })
                }
                type="primary"
                size="large"
                loading={loading}>
                Confirmar
              </Button>
              {dados.obrigatorio !== 1 && (
                <Button size="large" loading={loading} danger onClick={() => prorrogarTermo(dados && dados.id)}>
                  Deixar para depois
                </Button>
              )}
            </Space>
          </Space>
        </Form>
      </Row>
    );
  };
  // VAZIO
  const renderEmpty = () => {
    return (
      <div className="center">
        <Empty />
      </div>
    );
  };

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col xs={24} sm={24} md={22} lg={20} xl={20} xxl={14} align="left" className="content-item">
        <HeaderPage title="Configurações" backText="Sair" onClickBack={realizarLogout} />
        <HeaderTitle
          title="Termo de Ciência Confirmação"
          subtitle="Termos de ciência e concordância"
          icon={<FileDoneOutlined />}
          loading={loading}
        />
        <Divider />

        <Card bordered={false} bodyStyle={{ padding: "3%" }}>
          {loading || !dados.id ? renderEmpty() : renderTermo()}
        </Card>
      </Col>
      {contextHolder}
    </Row>
  );
};
